import React from 'react';
import { Phone, MessageCircle, MapPin } from 'lucide-react';
import { logoUrl, contactInfo, menuItems } from '../data/mock';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <img src={logoUrl} alt="Nova Eğitim" className="h-16 w-auto" />
            </Link>
            <p className="text-gray-400 leading-relaxed max-w-md mb-6">
              Nova Eğitim, öğrencilerin akademik başarılarını artırmak için kişiye özel eğitim çözümleri sunan güvenilir bir eğitim kurumudur.
            </p>
            <div className="flex gap-4">
              <a
                href={`https://wa.me/${contactInfo.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-green-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <MessageCircle className="w-5 h-5" />
              </a>
              <a
                href={`tel:${contactInfo.phone}`}
                className="w-10 h-10 bg-white/10 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <Phone className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Hızlı Linkler</h3>
            <ul className="space-y-3">
              {menuItems.map((item) => (
                <li key={item.label}>
                  {item.href.startsWith('/') ? (
                    <Link
                      to={item.href}
                      className="text-gray-400 hover:text-white transition-colors"
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <a
                      href={item.href}
                      className="text-gray-400 hover:text-white transition-colors"
                    >
                      {item.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6">İletişim</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                <a href={`tel:${contactInfo.phone}`} className="text-gray-400 hover:text-white transition-colors">
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400">
                  {contactInfo.address}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm">
              &copy; {currentYear} Nova Eğitim. Tüm hakları saklıdır.
            </p>
            <a 
              href="https://pastelweb.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-gray-500 hover:text-gray-300 transition-colors"
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_nova-egitim/artifacts/py8g8q3g_pastel%20logo.jpg" 
                alt="Pastel Web Yazılım" 
                className="h-6 w-auto rounded"
              />
              <span className="text-sm">Pastel Web Yazılım | Tüm hakları saklıdır.</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
